/* Soul zoom: product photos open in PhotoSwipe instead of Dawn's oversized lightbox.
   Fit to screen first, pinch / double-tap / wheel up to 4x, swipe between slides, swipe down or back to close.
   PhotoSwipe (assets/photoswipe.umd.min.js + .css) loads on the first touch of a photo. */
(() => {
  const data = document.querySelector('script[data-soul-zoom]'); if (!data) return;
  let items = []; try { items = JSON.parse(data.textContent); } catch (err) { return; }
  if (!items.length) return;

  let lib = null;
  const load = () => lib || (lib = new Promise((resolve, reject) => {
    const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = data.dataset.css; document.head.appendChild(css);
    const js = document.createElement('script'); js.src = data.dataset.js; js.onload = () => resolve(window.PhotoSwipe); js.onerror = reject; document.head.appendChild(js);
  }));
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  let pswp = null; let closingFromHistory = false;
  window.addEventListener('popstate', () => { if (pswp) { closingFromHistory = true; pswp.close(); } });

  const open = (PhotoSwipe, index) => {
    const dataSource = items.map((i) => (i.type === 'video'
      ? { html: `<div class="soul-zoom-video"><video src="${esc(i.src)}" poster="${esc(i.poster)}" controls playsinline loop preload="none"></video></div>` }
      : { src: i.src, msrc: i.msrc, width: i.width, height: i.height, alt: i.alt }));
    pswp = new PhotoSwipe({
      dataSource, index,
      bgOpacity: 1, showHideAnimationType: 'fade', wheelToZoom: true, closeOnVerticalDrag: true,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: (z) => z.fit * 2.5, // double-tap
      maxZoomLevel: (z) => z.fit * 4, // pinch cap: close enough for stones and plating, never absurd
      padding: { top: 56, bottom: 64, left: 0, right: 0 },
      arrowPrevTitle: 'Previous photo', arrowNextTitle: 'Next photo', closeTitle: 'Close', zoomTitle: 'Zoom',
    });
    pswp.on('uiRegister', () => {
      if (items.length < 2 || items.length > 12) return;
      pswp.ui.registerElement({
        name: 'soul-dots', className: 'soul-zoom-dots', appendTo: 'wrapper',
        onInit: (el, p) => {
          el.innerHTML = items.map((_, n) => `<button type="button" aria-label="Photo ${n + 1}"></button>`).join('');
          const dots = [...el.children]; dots.forEach((d, n) => d.addEventListener('click', () => p.goTo(n)));
          const paint = () => dots.forEach((d, n) => d.classList.toggle('is-active', n === p.currIndex));
          p.on('change', paint); paint();
        },
      });
    });
    // videos: play the one in view, pause the rest
    const syncVideos = () => document.querySelectorAll('.pswp video').forEach((v) => {
      const current = pswp.currSlide && pswp.currSlide.container && pswp.currSlide.container.contains(v);
      if (current) { v.muted = true; v.play().catch(() => {}); } else v.pause();
    });
    pswp.on('change', syncVideos); pswp.on('openingAnimationEnd', syncVideos);
    pswp.on('close', () => {
      document.documentElement.classList.remove('soul-zoom-open');
      if (!closingFromHistory && history.state && history.state.soulZoom) history.back();
      closingFromHistory = false;
    });
    pswp.on('destroy', () => { pswp = null; });
    document.documentElement.classList.add('soul-zoom-open');
    history.pushState({ soulZoom: true }, '');
    pswp.init();
  };

  document.addEventListener('pointerdown', (e) => { if (e.target.closest('.product__media-toggle')) load().catch(() => {}); }, { passive: true });
  // capture phase: runs before Dawn's modal opener, which never opens now
  document.addEventListener('click', async (e) => {
    const t = e.target.closest('.product__media-toggle'); if (!t || pswp) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const id = Number(String(t.dataset.mediaId || '').split('-').pop());
    const index = Math.max(0, items.findIndex((i) => i.id === id));
    let PhotoSwipe; try { PhotoSwipe = await load(); } catch (err) { return; }
    if (!pswp) open(PhotoSwipe, index);
  }, true);
})();
